(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/dialogs/user-suspension.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/dialogs/user-suspension.js');

'use strict';

class UserSuspension extends svs.tur.payment.dialogs.DialogBase {
  constructor() {
    let {
      onConfirm
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super({
      onConfirm
    });


    this.show();
  }
  getType() {
    return svs.components.dialog.type.ERROR;
  }
  getTitle() {
    return 'Du har en spelpaus aktiv';
  }
  getMessage() {
    return [{
      type: svs.components.dialog.message.TEXT,
      text: "G\xE5 till <a href=\"".concat(svs.core.urlMapping.get('gamingResponsibilityPause'), "\">Spelpaus</a> f\xF6r att l\xE4sa mer.")
    }];
  }
  getActions() {
    return [{
      type: svs.components.dialog.button.SECONDARY,
      title: 'Ok',
      callback: (e, forms, dialog) => {
        dialog.close();
        this.onConfirm && this.onConfirm();
      }
    }];
  }
}
svs.tur.payment.dialogs.UserSuspension = UserSuspension;

 })(window);